__webpack_require__.p = "https://www.manchesterpsychfest.com/";